import { trackInfraPageWeightView } from "@faire/web-api/events/infra/view/pageWeight";

import { getPageWeightInfo } from "./resourceTiming";
import { ResourceTimingCollector } from "./ResourceTimingCollector";
import { truncatePath } from "./truncatePath";
import { LoadTimingType, ActionName } from "./userPerceivedLoadTiming/types";

export const trackPageWeight = (
  path: string,
  pageName: ActionName,
  loadType: LoadTimingType,
  timeOfLastRouteChange: number
) => {
  const entries = ResourceTimingCollector.get().getResourceEntries(
    timeOfLastRouteChange
  );
  if (entries === undefined) {
    return;
  }
  const info = getPageWeightInfo(entries);

  trackInfraPageWeightView(
    JSON.stringify({ path: truncatePath(path), pageName, loadType }),
    JSON.stringify(info)
  );
};
